<template>
	<v-dialog v-model="showDialog" scrollable width="400px">
		<v-card>
			<v-card-title> Save view </v-card-title>
			<v-card-text>
				<v-text-field
					autofocus
					v-model="viewName"
					label="View name"
					:rules="[rules.required]"
				/>
				<v-switch
					v-if="canCreateGlobalView"
					v-model="isGlobal"
					class="mt-0"
					color="primary"
					hide-details
					label="Global View - visible to all Iris users"
				/>
			</v-card-text>

			<v-divider />
			<v-card-actions>
				<v-spacer />
				<v-btn text outlined @click="$emit('close')"> Close </v-btn>
				<v-btn color="primary" @click="save">
					<v-icon class="mr-2">mdi-content-save</v-icon>
					Save
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import permissionsMixin from '../../../mixins/permissionsMixin';
export default {
	name: 'SaveViewDialog',
	mixins: [permissionsMixin],
	props: {
		saveViewStoreAction: String,
		showDialog: Boolean,
		//Data grids and Inventory Form grids each have their own global view permission, they pass
		//it in. A grid that leaves it out keeps the plain "my own view" behaviour.
		globalViewPermission: String,
	},
	data() {
		return {
			viewName: '',
			isGlobal: false,
			rules: {
				required: (value) => !!value || 'Field is required',
			},
		};
	},
	computed: {
		canCreateGlobalView() {
			if (!this.globalViewPermission) return false;
			return this.hasPermissions([this.globalViewPermission]);
		},
	},
	methods: {
		save() {
			if (!this.viewName) return;
			if (!this.saveViewStoreAction) return;
			this.$store
				.dispatch(this.saveViewStoreAction, {
					Name: this.viewName,
					IsGlobal: this.canCreateGlobalView && this.isGlobal,
				})
				.then((success) => {
					if (!success) return;
					this.$emit('close');
				});
		},
		// async saveView() {
		//     let view = {
		//         Name: this.viewName,
		//         EntityId: this.grids.currentGridView.Entity.Id,
		//         ParentGridViewId: this.grids.currentGridView.Id,
		//         RowsPerPage: this.grids.rowsPerPage,
		//         Columns: this.grids.currentGridView.Columns.filter(
		//             (column) => column.IsVisible
		//         )
		//             .sort((a, b) => a.Order - b.Order)
		//             .map((column) => column.Id),
		//         AdvancedFilter: this.grids.advancedFilter,
		//         Sorting: this.grids.sorting || [],
		//     };

		//     this.$store.dispatch(GeneralActions.LOADING, true);
		//     dataService
		//         .saveView(view)
		//         .then(({ data }) => {
		//             this.currentGridView = data;
		//             this.$store.dispatch(GeneralActions.LOADING, false);
		//             this.$store.dispatch(GridsActions.RELOAD_GRID_VIEWS);
		//             this.showDialog = false;
		//         })
		//         .catch((error) => {
		//             this.$store.dispatch(GeneralActions.LOADING, false);
		//             this.$store.dispatch(GeneralActions.ERROR, error);
		//             this.showDialog = false;
		//         });
		// },
	},
};
</script>
